
function PageHeader({ title, subtitle, action }) {
  return (
    <div className="cc-page-title">
      <div>
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
      {action && <div>{action}</div>}
    </div>
  );
}
export default PageHeader;
